'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n  '], ['\n    display: block;\n    width: 100%;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectionButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'SelectionButtonWrapper'
})(['width:33.333333%;width:calc(100% / 3);', ';'], _responsiveBreakpoints2.default.phone(_templateObject));

exports.default = SelectionButtonWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/SelectionButtonWrapper.js
// module id = 741
// module chunks = 3 4